export default {
  props: {
    valueBoolean: Boolean,
  },
}
